import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return ['suggestions', 'searchForm', 'selectedItemDisplay', 'selectedItem'];
  }

  initialize(){
    this.search = _.throttle(this.search, 400);
    window.addEventListener('turbolinks:visit', function(){localStorage.removeItem('auto-suggest-product-prev-params')});
  }

  connect(){
    let prev_params = localStorage.getItem('auto-suggest-product-prev-params') ;
    if( prev_params){
      this.search_with_prev_params(prev_params);
    }
    else { 
      this.search();
    }
  }

  search(e){
    let t = this;
    let form = t.searchFormTarget;
    let formType = t.data.has('type') ? "&form_type=" + t.data.get('type') : "";

    let formAction  = t.data.has('action') ? "&form_action=" + encodeURI(t.data.get('action')) : "";
    axios.defaults.headers.common['Accept'] = 'application/json';
    let search_params  =  $(form).serialize(); 
    localStorage.setItem('auto-suggest-product-prev-params', search_params); 
    axios.get(form.action + '?' + search_params + formType + formAction)
      .then(function(response){
        t.suggestionsTarget.innerHTML = response.data; 
      }).catch(function(err){
        console.log(err);
      }) 
  }


  search_with_prev_params(prev_params){ 
    let t= this;
    let form = t.searchFormTarget;
    let formType = t.data.has('type') ? "&form_type=" + t.data.get('type') : "";

    let formAction  = t.data.has('action') ? "&form_action=" + encodeURI(t.data.get('action')) : "";
    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.get(form.action + '?' + prev_params + formType + formAction)
      .then(function(response){
        t.suggestionsTarget.innerHTML = response.data; 
      }).catch(function(err){
        console.log(err);
      }) 

  }
  selectItem(event){
    console.log(event);
  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/auto_suggest_form_controller.js